import { theme } from '@styles';

export const styles = {
  modalContainerProps: {
    backgroundColor: theme.colors.white[10],
    border: `1px solid ${theme.colors.white[10]}`,
  },
};

export const getButtonWidth = ({ isTabletSM }) => (isTabletSM ? 'auto' : 240);
